import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06a2b85e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-container"
};
import { ref } from "vue";
import Dialog from "./components/dialog.vue";
// import AssignTask from "./components/assignTask.vue";
import api from "@/api/task";
import userApi from "@/api/system/users";
import { useDel } from "@/hook/useDel";
// import { useStore } from "@/store/index";
import { onMounted } from "vue";
import { ElMessage } from "element-plus";
import { t } from "@/utils";
// import { useI18n } from "vue-i18n";
// import { ElMessage } from "element-plus";
// const store = useStore();
// const { t } = useI18n();
// const params = reactive({
//   page: 1,
//   limit: 10,
//   uid: "",
//   status: undefined,
//   platform: 0,
//   rechargeStatus: 0,
// });

export default {
  __name: 'index',
  setup(__props) {
    const dialogRef = ref(null);
    const list = ref([]);
    const loading = ref(false);
    const total = ref(0);
    const userList = ref([]);
    const assignLoading = ref(false);
    const loadList = async () => {
      loading.value = true;
      try {
        const {
          data
        } = await api.configList();
        if (data.code !== 0) return;
        list.value = data.data.list || [];
        total.value = data.data.total;
      } finally {
        loading.value = false;
      }
    };
    onMounted(() => {
      loadList();
      getUserList();
    });
    const getUserList = async () => {
      const {
        data: {
          data
        }
      } = await userApi.selectUser();
      userList.value = data && data.list || [];
    };
    const handleClick = val => {
      dialogRef.value.open(val);
    };
    const handleDel = async val => {
      useDel(async () => {
        await api.configDel({
          id: val.id
        });
        ElMessage.success(t("action.success"));
        loadList();
      });
    };
    const handleAssign = async () => {
      assignLoading.value = true;
      const {
        data
      } = await api.autoAssign();
      if (data.code === 0) {
        ElMessage.success(t("action.success"));
      }
      assignLoading.value = false;
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_card, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          size: "large",
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "success",
              onClick: _cache[0] || (_cache[0] = $event => handleClick())
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.add")), 1)]),
              _: 1
            })), [[_directive_permission, '/task/config/add']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              loading: assignLoading.value,
              onClick: _cache[1] || (_cache[1] = $event => handleAssign())
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("task.config.autoAssign")), 1)]),
              _: 1
            }, 8, ["loading"])), [[_directive_permission, '/task/auto_assign']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = $event => loadList())
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.refresh")), 1)]),
              _: 1
            })), [[_directive_permission, '/task/config/list']])]),
            _: 1
          })]),
          _: 1
        })]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          style: {
            "margin-bottom": "20px"
          },
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: _ctx.$t('task.config.uid'),
            prop: "uid"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.config.username'),
            prop: "username"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.config.num'),
            prop: "num"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.config.todayCnt'),
            prop: "todayCnt"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('common.action'),
            fixed: "right"
          }, {
            default: _withCtx(({
              row
            }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => handleClick(row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.edit")), 1)]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, '/task/config/edit']]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "danger",
              onClick: $event => handleDel(row)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("common.del")), 1)]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, '/task/config/del']])]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["data", "onSelectionChange"])), [[_directive_loading, loading.value]]), _createVNode(Dialog, {
          ref_key: "dialogRef",
          ref: dialogRef,
          userList: userList.value,
          onInit: loadList
        }, null, 8, ["userList"])]),
        _: 1
      });
    };
  }
};